import { useMutation } from "@tanstack/react-query";

import { usersKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useUnarchiveUser(userId: number | undefined) {
  return useMutation({
    mutationFn: async () =>
      await apiClient.url(`/users/unarchive/${userId}`).patch().json(),
    mutationKey: usersKeys.unarchive(userId),
  });
}
